"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMessage = exports.deleteMessages = exports.viewMessages = exports.getMessages = exports.GET_MESSAGES = void 0;

var _avlComponents = require("@availabs/avl-components");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GET_MESSAGES = "AMS::GET_MESSAGES";
exports.GET_MESSAGES = GET_MESSAGES;

var getMessages = function getMessages() {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      var _Config = (0, _utils.Config)(),
          AUTH_HOST = _Config.AUTH_HOST,
          PROJECT_NAME = _Config.PROJECT_NAME;

      (0, _utils.postJson)("".concat(AUTH_HOST, "/messages"), {
        token: token,
        project: PROJECT_NAME
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(_objectSpread({
            type: GET_MESSAGES
          }, res));
        }
      })["catch"](function (e) {
        (0, _avlComponents.sendSystemMessage)(e);
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.getMessages = getMessages;

var viewMessages = function viewMessages(ids) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      var _Config2 = (0, _utils.Config)(),
          AUTH_HOST = _Config2.AUTH_HOST;

      (0, _utils.postJson)("".concat(AUTH_HOST, "/messages/view"), {
        token: token,
        ids: ids
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getMessages());
        }
      })["catch"](function (e) {
        (0, _avlComponents.sendSystemMessage)(e);
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.viewMessages = viewMessages;

var deleteMessages = function deleteMessages(ids) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      var _Config3 = (0, _utils.Config)(),
          AUTH_HOST = _Config3.AUTH_HOST;

      (0, _utils.postJson)("".concat(AUTH_HOST, "/messages/delete"), {
        token: token,
        ids: ids
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getMessages());
        }
      })["catch"](function (e) {
        (0, _avlComponents.sendSystemMessage)(e);
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.deleteMessages = deleteMessages;

var postMessage = function postMessage(heading, message, type, target) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      var _Config4 = (0, _utils.Config)(),
          AUTH_HOST = _Config4.AUTH_HOST,
          PROJECT_NAME = _Config4.PROJECT_NAME;

      return (0, _utils.postJson)("".concat(AUTH_HOST, "/messages/post"), {
        token: token,
        heading: heading,
        message: message,
        type: type,
        target: target,
        project: PROJECT_NAME
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else if (res.message) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.message, {
            type: "Info"
          }));
        }
      });
    } else {
      return Promise.resolve();
    }
  };
}; // export const viewMessages = ids =>
// 	(dispatch, getState) => {
// 		if (!Array.isArray(ids)) ids = [ids];
// 		const { token } = getState().user;
// 		if (token) {
// 			postJson("/message/view", { token, ids })
// 				.then(res => {
// 					if (res.error) {
// 						dispatch(message(res.error));
// 					}
// 					else {
// 						dispatch(getMessages())
// 					}
// 				})
// 		}
// 		else {
// 			return Promise.resolve();
// 		}
// 	}
//
// export const deleteMessages = ids =>
// 	(dispatch, getState) => {
// 		if (!Array.isArray(ids)) ids = [ids];
// 		const { token } = getState().user;
// 		if (token) {
// 			postJson("/message/delete", { token, ids })
// 				.then(res => {
// 					if (res.error) {
// 						dispatch(message(res.error));
// 					}
// 					else {
// 						dispatch(getMessages())
// 						if (res.message) {
// 							dispatch(message(res.message));
// 						}
// 					}
// 				})
// 		}
// 		else {
// 			return Promise.resolve();
// 		}
// 	}
//
// export const postMessage = (heading, msg, type, target, project) =>
// 	(dispatch, getState) => {
// 		const { token } = getState().user;
// 		if (token) {
// 			postJson("/message/post", { token, heading, message: msg, type, target, project })
// 				.then(res => {
// 					if (res.error) {
// 						dispatch(message(res.error));
// 					}
// 					else if (res.message) {
// 						dispatch(message(res.message));
// 					}
// 				})
// 		}
// 		else {
// 			return Promise.resolve();
// 		}
// 	}


exports.postMessage = postMessage;